<div class="main-content">
  <div
    class="color-strip"
    [style.width]="viewModel.colorStripWidth$ | async"
    [style.background-color]="viewModel.strainTypeColor$ | async"></div>
  <div class="empty-space"></div>
</div>
